var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"id"},[_c('div',{staticClass:"box"}),_c('div',{staticClass:"right_image"},[_c('div',{staticClass:"right_list"},_vm._l((_vm.rightList),function(item,index){return _c('div',{key:index,staticClass:"right_list_info",on:{"click":function($event){return _vm.goTo(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }